var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import Skeleton from 'react-loading-skeleton';
import { Table, TableData, TableWrapper, TableRow, EmptyOverlay } from './styles';
import Row from './components/Row';
import TableHead from './components/TableHead';
import Pagination from './components/Pagination';
import PaddingRows from './components/PaddingRows';
function ServerPaginatedTable(_a) {
    var _b;
    var columns = _a.columns, fetchData = _a.fetchData, queryKey = _a.queryKey, getRowKey = _a.getRowKey, _c = _a.enabled, enabled = _c === void 0 ? true : _c, _d = _a.rowsPerPage, rowsPerPage = _d === void 0 ? 10 : _d, rowActions = _a.rowActions, emptyMessage = _a.emptyMessage;
    var _e = useState(), order = _e[0], setOrder = _e[1];
    var _f = useState(1), page = _f[0], setPage = _f[1];
    var _g = useQuery(__spreadArrays(queryKey, [order, page]), function () {
        return fetchData({
            page: page,
            order: order,
        });
    }, { enabled: enabled }), response = _g.data, refetch = _g.refetch, isLoading = _g.isLoading;
    useEffect(function () {
        setPage(1);
    }, __spreadArrays(queryKey));
    // This effect handles cases in which rows were deleted and
    // we're currently in a page that does not exist anymore
    useEffect(function () {
        if ((response === null || response === void 0 ? void 0 : response.totalPages) !== undefined && page > response.totalPages) {
            setPage(response.totalPages || 1);
        }
    }, [response === null || response === void 0 ? void 0 : response.totalPages]);
    var handlePageChange = function (newPageNumber) {
        setPage(newPageNumber);
    };
    var handleHeaderClick = function (column) {
        if (!order) {
            setOrder({
                order_by: column.sortingFieldName,
                direction: 'ASC',
            });
        }
        else if (order.order_by !== column.sortingFieldName) {
            setOrder({
                order_by: column.sortingFieldName,
                direction: 'ASC',
            });
        }
        else if (order.direction === 'ASC') {
            setOrder(__assign(__assign({}, order), { direction: 'DESC' }));
        }
        else {
            setOrder(undefined);
        }
    };
    var tableRows = [];
    if (isLoading) {
        tableRows = Array(rowsPerPage)
            .fill(0)
            .map(function (_, index) { return (React.createElement(TableRow, { key: index }, columns.map(function (column) { return (React.createElement(TableData, { key: column.label },
            React.createElement(Skeleton, { width: "100%", height: 10 }))); }))); });
    }
    else if (response) {
        tableRows = response.data.map(function (row) { return (React.createElement(Row, { key: getRowKey(row), columns: columns, row: row, rowActions: rowActions })); });
        if (tableRows.length < rowsPerPage) {
            tableRows = __spreadArrays(tableRows, PaddingRows({
                columns: columns,
                count: rowsPerPage - tableRows.length,
                rowActions: rowActions,
            }));
        }
    }
    var hasNoData = !isLoading && (response === null || response === void 0 ? void 0 : response.data.length) === 0;
    var shouldShowEmptyMessage = hasNoData;
    var effectiveEmptyMessage = emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : 'No hay resultados disponibles';
    return (React.createElement("div", null,
        React.createElement(TableWrapper, null,
            React.createElement(Table, null,
                React.createElement(TableHead, { columns: columns, onHeaderClick: handleHeaderClick, order: order, rowActions: rowActions }),
                React.createElement("tbody", null, tableRows)),
            shouldShowEmptyMessage && (React.createElement(EmptyOverlay, null, effectiveEmptyMessage))),
        React.createElement(Pagination, { currentPage: page, totalPages: (_b = response === null || response === void 0 ? void 0 : response.totalPages) !== null && _b !== void 0 ? _b : 1, onPageChange: handlePageChange })));
}
export default ServerPaginatedTable;
